import { createTheme } from "@mui/material";

/*
 * Brand pallet:
 * #FF5A4E - Coral Burst (orange/pink)
 * #3D1F47 - Deep Plum
 * #FFE8D6 - Peach Cream
 * #FF9E6D - Apricot
*/

export const marlinTheme = createTheme({
  components: {
    MuiTooltip: {
      styleOverrides: {
        tooltip: {
          fontSize: 14,
        }
      }
    }
  },
  palette: {
    primary: {
      main: '#6B367C'
    },
    secondary: {
      main: '#FF5A4E'
    },
    info: {
      main: '#6B367C'
    },
    warning: {
      main: '#FF5A4E'
    }
  },
});
